export default __webpack_public_path__ + "static/media/curated_meals.ed85427d.jpg";